export default {
      id: "syslog-usage",
      viewBox: "0 0 548.291 548.291",
      url: __webpack_public_path__ + "img/icons.dd84271a.svg#syslog",
      toString: function () {
        return this.url;
      }
    }